import React from 'react';
import type { BetWonNotifyEvent } from '../../lib/userNotify';
import { betWonTitle, betWonHorseLine, formatProfit } from '../../lib/notifyDisplay';

type Props = {
  event: BetWonNotifyEvent;
  onClick: () => void;
  onDismiss: () => void;
};

const BetWonToast: React.FC<Props> = ({ event, onClick, onDismiss }) => {
  return (
    <div
      className="notify-toast-item"
      role="status"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="notify-toast-header">
        <img
          src="/white_favicon.png"
          alt=""
          className="notify-toast-logo"
          width={22}
          height={22}
        />
        <span className="notify-toast-header-text">{betWonTitle()}</span>
        <button
          type="button"
          className="notify-toast-close"
          aria-label="Dismiss"
          onClick={(e) => {
            e.stopPropagation();
            onDismiss();
          }}
        >
          ×
        </button>
      </div>
      <div className="notify-toast-body">
        <div className="notify-toast-horse">{betWonHorseLine(event)}</div>
        <div className="notify-toast-profit">{formatProfit(event.profit, event.currency)}</div>
        <div className="notify-toast-hint">Tap to view open bets</div>
      </div>
    </div>
  );
};

export default BetWonToast;
